import React from 'react';
import { Drawer, Typography } from 'antd';
var {
  Link,
  Paragraph,
  Text,
  Title
} = Typography;
export default function DrawerQueryBuilder(_ref) {
  var {
    closeDrawer,
    drawerVisible
  } = _ref;
  return /*#__PURE__*/React.createElement(Drawer, {
    title: "Query Builder",
    placement: "right",
    closable: true,
    onClose: closeDrawer,
    visible: drawerVisible
  }, /*#__PURE__*/React.createElement(Paragraph, null, "The query builder is a powerful tool to help users easily explore data, customize queries and discover data insights."), /*#__PURE__*/React.createElement(Title, {
    level: 4
  }, "List Seperator"), /*#__PURE__*/React.createElement(Paragraph, null, "By default, Excel uses the list separator defined under regional settings in Control Panel. The US English version of Excel uses a comma (,) for list separator by default, while other international versions may use a semicolon (;)."), /*#__PURE__*/React.createElement(Paragraph, null, "This impacts how functions are entered in Excel. In the United States, and countries like Canada, Australia, United Kingdom, etc. functions are entered with arguments separated by commas. In other countries like Spain, France, Italy, Netherlands, Germany, functions are entered with semicolons."), /*#__PURE__*/React.createElement(Paragraph, null, "For example, the SUM would be entered like this in the US:"), /*#__PURE__*/React.createElement(Paragraph, null, /*#__PURE__*/React.createElement(Text, {
    code: true
  }, "=SUM(A1,C1,E1)")), /*#__PURE__*/React.createElement(Paragraph, null, "And like this in Italy:"), /*#__PURE__*/React.createElement(Paragraph, null, /*#__PURE__*/React.createElement(Text, {
    code: true
  }, "=SUM(A1;C1;E1)")), /*#__PURE__*/React.createElement(Paragraph, null, /*#__PURE__*/React.createElement(Link, {
    href: "https://intercom.help/cryptosheets/en/articles/4474215-international-syntax-for-custom-functions",
    target: "_blank"
  }, "Link to further explanation")));
}